<!-- <div *ngIf="loadingData" class="loading-container">
  <app-loader [loaded]="false"></app-loader>
  <div class="loading-text">Loading form data...</div>
</div> -->

<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times"></i>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body" [hidden]="minimise">
  @if (!loadingData) {
<div class="f3800-piii-consol-container">

  <!-- Header Information -->
  <div class="entity-info">
    <h3>
      <span class="LayerLine1">Entity:</span><span class="LayerData1">{{formDataObj.entityName + " : " + formDataObj.taxYearBegin + " - " + formDataObj.taxYearEnd}}</span>
    </h3>
    <h3>
      <span class="LayerLine1">Business:</span><span class="LayerData1">{{formDataObj.meCode + " - " + formDataObj.meName}}</span>
    </h3>
    <h3>
      <span class="LayerLine1">Tax Code:</span><span class="LayerData1">{{formDataObj.taxCode}}</span>
    </h3>
  </div>

  <!-- Tab Container -->
  @if (batchSelect) {
<div class="tab-container">
    
    <!-- Tab Navigation -->
    <div class="tab-navigation">
      @for (item of defaultsMultipleSelected; track itemTracker($index, item)) {
<button 
       
        class="tab-button"
        [class.active]="activeTab === item.subForm"
        (click)="onTabChange(item)">
        {{item.subForm}}
      </button>
}
    </div>

    <!-- Tab Content -->
    <div class="tab-content">

      <!-- Dynamic Form Content based on activeTab -->
      @for (item of defaultsMultipleSelected; track itemTracker($index, item)) {
<div class="tab-pane active" 
           [hidden]="activeTab !== item.subForm">

        <!-- Standard Form Template (F8912, F8820, F8941 excluded) -->
        @if (activeTab != 'F8912' && activeTab != 'F8820' && activeTab != 'F8941') {
<div>
          
          <!-- Form Header -->
          @if (formHeader && formHeader.length > 0) {
<div class="form-header-section">
            <table class="table table-striped table-bordered customTable table-custom-bg custom-table">
              <thead>
                <tr>
                  @for (header of formHeader; track itemTracker($index, header)) {
<th class="sticky-col">
                    {{header.ATTRIB_DESCRIPTION}}
                  </th>
}
                </tr>
              </thead>
            </table>
          </div>
}

          <!-- Main Form Table -->
          <div class="form-table-section">
            <div class="table-scroll">
              <table class="table table-striped table-bordered customTable table-custom-bg custom-table">
                
                <!-- Table Headers -->
                <thead>
                  <tr>
                    <th class="sticky-col">Line No.</th>
                    <th class="sticky-col">Description</th>
                    @for (val of tableHeader; track itemTracker($index, val)) {
<th class="sticky-col">
                      {{val.ATTRIB_DESCRIPTION}}
                    </th>
}
                  </tr>
                </thead>

                <!-- Table Body -->
                <tbody>
                                  @for (row of outerList | filter: 'Y' : 'IS_FORM_DISPLAY'; track itemTracker(i, row); let i = $index) {
<tr 
                  
                  class="table1">
                    
                    <!-- Line Number -->
                    @if (row.ROW_TYPE != 'PH') {
<td>{{row.LINE_DISP}}</td>
}
                    @if (row.ROW_TYPE == 'PH') {
<td [ngClass]="{'color-red': row.ROW_TYPE == 'PH'}">
                      <b>{{row.LINE_DISP}}</b>
                    </td>
}

                    <!-- Description -->
                    @if (row.ROW_TYPE == 'PH') {
<td [ngClass]="{'color-red': row.ROW_TYPE == 'PH'}">
                      <span><b>{{row.DESCRIPTION}}</b></span>
                    </td>
}
                    @if (row.ROW_TYPE != 'PH') {
<td>{{row.DESCRIPTION}}</td>
}

                    <!-- Form Data Cells -->
                    @for (row1 of formList | filter: 'Y' : 'IS_FORM_DISPLAY'; track itemTracker($index, row1)) {
<td 
                      style="width: 220px;" 
                     
                      [ngStyle]="{'display': row1.FORM_LINE_KEY == row.FORM_LINE_KEY && row1.EDIT_TYPE != 'radio' ? 'table-cell' : 'none'}">
                      
                      <!-- Non-editable cells -->
                      @if (row1.IS_EDITABLE_CELL == 'N' && row1.EDIT_TYPE != 'radio') {
<div 
                        style="text-align: right; padding-right: 10px" 
                       
                        [ngClass]="{'color-red': row1.ATTRIB_VALUE < 0}">
                        <span>{{row1.ATTRIB_VALUE | number}}</span>
                      </div>
}

                      <!-- Editable input fields -->
                      @if (row1.IS_EDITABLE_CELL == 'Y' && row1.EDIT_TYPE != 'checkbox' && row1.EDIT_TYPE != 'radio' && row1.EDIT_TYPE != 'custom_date_various' && row1.EDIT_TYPE != 'dropdown') {
<div 
                        style="text-align: right; padding-right: 10px" 
                       >
                        
                        <!-- Number input -->
                        @if (row1.DATA_TYPE == 'number') {
<div>
                          <input 
                            class="form-control input-md numText"
                            style="text-align: right" 
                            type="text"
                            [(ngModel)]="row1.ATTRIB_VALUE"
                            [disabled]="row1.is_editable"
                            placeholder=""
                            (change)="validateSubForm(row1)">
                        </div>
}

                        <!-- String input -->
                        @if (row1.DATA_TYPE == 'string') {
<div>
                          <input 
                            class="form-control input-md numText"
                            style="text-align: right" 
                            type="text"
                            [(ngModel)]="row1.ATTRIB_VALUE"
                            [disabled]="row1.is_editable"
                            placeholder=""
                            (change)="validateSubForm(row1)">
                        </div>
}
                      </div>
}

                      <!-- Checkbox fields -->
                      @if (row1.EDIT_TYPE == 'checkbox') {
<div 
                        style="padding-left: 25px" 
                       >
                        <input 
                          type="checkbox" 
                          [checked]="row1.ATTRIB_VALUE === 'true'"
                          (change)="onCheckboxChange($event, row1)">
                        {{row1.ATTRIB_DESCRIPTION}}
                      </div>
}

                      <!-- Dropdown fields -->
                      @if (row1.EDIT_TYPE == 'dropdown') {
<div 
                        style="padding-left: 25px" 
                       >
                        <select 
                          style="width: 200px" 
                          class="form-control" 
                          [(ngModel)]="row1.ATTRIB_VALUE"
                          (change)="validateSubForm(row1)">
                          <option value="">Select</option>
                          @for (s of formLOV; track itemTracker($index, s)) {
<option 
                            
                            [value]="s.CODE_NAME">
                            {{s.CODE_DESC}}
                          </option>
}
                        </select>
                      </div>
}

                      <!-- Date picker fields -->
                      @if (row1.EDIT_TYPE == 'custom_date_various') {
<div 
                        style="padding-left: 25px" 
                       >
                        <input
                          type="date"
                          class="form-control"
                          [(ngModel)]="row1.ATTRIB_VALUE"
                          (change)="validateSubForm(row1)">
                      </div>
}

                    </td>
}

                    <!-- Radio button cells for normal forms -->
                    @if (row.EDIT_TYPE == 'radio' && activeTab != 'F8936') {
<td 
                      style="width: 183px; text-align: left; padding-right: 10px;" 
                     >
                      @for (row1 of formList | filter: {EDIT_TYPE: 'radio'}; track itemTracker($index, row1)) {
<div 
                        
                        [ngStyle]="{'display': row1.EDIT_TYPE == 'radio' && row1.FORM_LINE_KEY == row.FORM_LINE_KEY ? 'block' : 'none'}">
                        <input 
                          type="checkbox" 
                          [checked]="row1.ATTRIB_VALUE === 'true'"
                          (change)="onRadioCheckboxChange($event, row1)">
                        {{row1.ATTRIB_DESCRIPTION}}
                      </div>
}
                    </td>
}

                    <!-- Radio button cells for F8936 - Column A -->
                    @if (row.EDIT_TYPE == 'radio' && activeTab == 'F8936') {
<td 
                      style="width: 183px; text-align: left; padding-right: 10px; cellspacing: 0; cellpadding: 0;" 
                     >
                      @for (row2 of formList | filter: {EDIT_TYPE: 'radio'}; track itemTracker($index, row2)) {
<div 
                        
                        [ngStyle]="{'display': row2.EDIT_TYPE == 'radio' && row2.FORM_LINE_KEY == row.FORM_LINE_KEY && row2.ATTRIB_COL == 'a' ? 'block' : 'none'}">
                        <input 
                          type="checkbox" 
                          [checked]="row2.ATTRIB_VALUE === 'true'"
                          (change)="onRadioCheckboxChange($event, row2)">
                        {{row2.ATTRIB_DESCRIPTION}}
                      </div>
}
                    </td>
}

                    <!-- Radio button cells for F8936 - Column B -->
                    @if (row.EDIT_TYPE == 'radio' && activeTab == 'F8936') {
<td 
                      style="width: 183px; text-align: left; padding-right: 10px;" 
                     >
                      @for (row3 of formList | filter: {EDIT_TYPE: 'radio'}; track itemTracker($index, row3)) {
<div 
                        
                        [ngStyle]="{'display': row3.EDIT_TYPE == 'radio' && row3.FORM_LINE_KEY == row.FORM_LINE_KEY && row3.ATTRIB_COL == 'b' ? 'block' : 'none'}">
                        <input 
                          type="checkbox" 
                          [checked]="row3.ATTRIB_VALUE === 'true'"
                          (change)="onRadioCheckboxChange($event, row3)">
                        {{row3.ATTRIB_DESCRIPTION}}
                      </div>
}
                    </td>
}

                  </tr>
}
                </tbody>

              </table>
            </div>
          </div>

        </div>
}

        <!-- F8912 Specific Template -->
        @if (activeTab == 'F8912') {
<div class="f8912-template">
          <ap-notification [id]="'f3800-f8912-info'" [isNotice]="true" [position]="'static'"
              [closeable]="false" [animation]="false">
          </ap-notification>
          <!-- Placeholder for F8912 specific content -->
          <div class="form-placeholder">
            F8912 form content would be loaded here with specific template structure.
          </div>
        </div>
}

        <!-- F8820 Specific Template -->
        @if (activeTab == 'F8820') {
<div class="f8820-template">
          <ap-notification [id]="'f3800-f8820-info'" [isNotice]="true" [position]="'static'"
              [closeable]="false" [animation]="false">
          </ap-notification>
          <!-- Placeholder for F8820 specific content -->
          <div class="form-placeholder">
            F8820 form content would be loaded here with specific template structure.
          </div>
        </div>
}

        <!-- F8941 Specific Template -->
        @if (activeTab == 'F8941') {
<div class="f8941-template">
          <ap-notification [id]="'f3800-f8941-info'" [isNotice]="true" [position]="'static'"
              [closeable]="false" [animation]="false">
          </ap-notification>
          <!-- Placeholder for F8941 specific content -->
          <div class="form-placeholder">
            F8941 form content would be loaded here with specific template structure.
          </div>
        </div>
}

      </div>
}

    </div>

  </div>
}

  <!-- Single Form Mode (non-batch) -->
  @if (!batchSelect) {
<div class="single-form-container">
    
    <!-- Form Header -->
    @if (formHeader && formHeader.length > 0) {
<div class="form-header-section">
      <table class="table table-striped table-bordered customTable table-custom-bg custom-table">
        <thead>
          <tr>
            @for (header of formHeader; track itemTracker($index, header)) {
<th class="sticky-col">
              {{header.ATTRIB_DESCRIPTION}}
            </th>
}
          </tr>
        </thead>
      </table>
    </div>
}

    <!-- Main Form Table (same structure as batch mode) -->
    <div class="form-table-section">
      <div class="table-scroll">
        <table class="table table-striped table-bordered customTable table-custom-bg custom-table">
          <!-- Same table structure as in batch mode -->
          <!-- This would be repeated here for single form mode -->
        </table>
      </div>
    </div>

  </div>
}



</div>
}

<!-- Modal Footer -->
<div class="modal-footer" [hidden]="minimise">
  <!-- Batch Select Buttons -->
  @if (batchSelect) {
<div>
    <button 
      class="a-btn a-btn-primary a-btn-lg" 
      style="background-color: rgb(70, 184, 218);"
      type="button" 
      (click)="save()" 
      [disabled]="isSaveClicked || crudLoading">
      @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
      Save
    </button>
    <button 
      class="a-btn a-btn-gray a-btn-lg" 
      type="button" 
      (click)="reset()">
      Reset
    </button>
    <button 
      class="a-btn a-btn-primary a-btn-lg" 
      type="button" 
      (click)="cancelForm()">
      Close Form
    </button>
  </div>
}

  <!-- Single Form Buttons -->
  @if (!batchSelect) {
<div>
    @if (currentTabName != 'Subsidiary') {
<button 
            class="save-button" 
            type="button" 
            [disabled]="isSaveClicked || crudLoading" 
            (click)="save()">
      @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save and Proceed
    </button>
}
    @if (currentTabName != 'Subsidiary') {
<button 
            class="reset-button" 
            type="button" 
            (click)="reset()">Reset</button>
}
      <button class="cancel-button" 
          type="button" 
          (click)="cancel()">Cancel</button>
  </div>
}
</div> 